
import React, { Component } from 'react';
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { getArBucketItems } from "../../_services/accountsPayable.service";
import api from '../../_services/apiUrl';
import { getUPSResponse, getFedExTrackingResponse } from "../../_services/displayOrder.service";
import appConstants from "../../_services/applicationConstant";
import UPSTrackingNumbersCard from "./UPSTrackingNumbersCard";
import { decryptData } from '../../Utils';
class UPSTrackingInfo extends Component {
  constructor(props) {
    super(props);
    const salt = process.env.SALT || process.env.REACT_APP_KEY;
    const originalData = decryptData(localStorage.getItem("id_token"), salt);
    this.state = {
      companyNumber: localStorage.getItem('companyNumber'),
      customerNumber: localStorage.getItem('customerNumber'),
      jwtToken: originalData,

      colHeaders: [
        {
          headerName: "Date", tooltip: (params) => 'Click to show the details', cellStyle: { textAlign: 'center', borderRight: '0.1px solid lightgray' },
          field: "deliveryDate", width: 260, headerClass: `${appConstants.isR3App ? "gridheaderR3" : "gridheader"}`
        },
        { headerName: "Time", type: 'rightAligned', cellStyle: { textAlign: 'right', borderRight: '0.1px solid lightgray' }, tooltip: (params) => 'Click to show the details', field: "deliveryTime", width: 240, headerClass: `${appConstants.isR3App ? "gridheaderR3" : "gridheader"}` },

        { headerName: "Location", type: 'rightAligned', cellStyle: { textAlign: 'right' }, tooltip: (params) => 'Click to show the details', field: "city", width: 320, headerClass: `${appConstants.isR3App ? "gridheaderR3" : "gridheader"}` },
        { headerName: "Activity", type: 'rightAligned', cellStyle: { textAlign: 'right' }, tooltip: (params) => 'Click to show the details', field: "Status", width: 290, headerClass: `${appConstants.isR3App ? "gridheaderR3" : "gridheader"}` }],
    
      colHistoryHeaders: [
                    {
                      headerName: "Date", tooltip: (params) => 'Click to show the details', cellStyle: { textAlign: 'center', borderRight: '0.1px solid lightgray' },
                      field: "date", width: 260, headerClass: `${appConstants.isR3App ? "gridheaderR3" : "gridheader"}`
                    },
                    { headerName: "Description", type: 'rightAligned', cellStyle: { textAlign: 'left' }, tooltip: (params) => 'Click to show the details', field: "eventDescription", width: 290, headerClass: `${appConstants.isR3App ? "gridheaderR3" : "gridheader"}` },
            
                    { headerName: "Status", type: 'rightAligned', cellStyle: { textAlign: 'center' }, tooltip: (params) => 'Click to show the details', field: "derivedStatus", width: 290, headerClass: `${appConstants.isR3App ? "gridheaderR3" : "gridheader"}` },
            
                    { headerName: "Location", type: 'rightAligned', cellStyle: { textAlign: 'center' }, tooltip: (params) => 'Click to show the details', field: "city", width: 290, headerClass: `${appConstants.isR3App ? "gridheaderR3" : "gridheader"}` },
            
                  ],

      rowData: [],
      trackData: [],
      trackHistory: [],
      status: '',
      weight: '',
      trackinginofnumber: '',
      selectTrackingNumber: '',
      description: '',
      rowClassRules: {
        'total-row': function (params) {
          var rowVal = params.data.Name;
          return rowVal === 'Total';
        },
      },

    };
  };
  componentDidMount() {
    getUPSResponse(
      this.props.upsTrackingNumber, this.props.isFedex
    ).then((data) => {

      if (data.length > 0) {
        if(!this.props.isFedex) 
          this.setState({ trackData: data }) 
         else this.setState({ trackData: data[0].scanEvents })

        this.setState({ status: data[0].Status });
        this.setState({ weight: data[0].weightField });
        this.setState({ trackinginofnumber: data[0].trackingNumber })
        this.setState({ description: data[0].description })

        
      }

      else {
        this.setState({
          show: true,
          userMessage:
            "No matching Orders have been found.",
        });
      }
    });

    
  //   if(this.state.isfedex){
  //   getFedExTrackingResponse(
  //     this.props.upsTrackingNumber, this.props.isFedex
  //   ).then((data1) => {

  //     if (data1.length > 0) {
  //       console.log('travel history-1-', data1);
  //       this.setState({ trackData: data1 })

  //     }

  //   })
  // }

  }
  rowclicked = (TrackNumber) => {


    getUPSResponse(TrackNumber)
      .then((data) => {
        if (data !== null) {
          this.setState({ rowData: data })
          console.log('rowdata-',data)
        }
      });

    getFedExTrackingResponse(TrackNumber)
      .then((data1) => {
        if (data1 !== null) {

          this.setState({ trackdata: data1 });
          console.log('tack hostory-2-,', data1)
        }
      });
  }

  render() {
    const renderARBucketGrid = () => {
      return <div className={`ag-theme-alpine ${appConstants.isR3App ? "apGridR3" : "apGrid"}`}
        style={{ height: '220px' }}>
          
        <AgGridReact
          columnDefs={this.state.colHeaders }
          rowData={ this.props.trackData }
          //onGridReady={this.onGridReady}  
          rowHeight="30"
          headerHeight="30"
          rowSelection="single"
          rowClassRules={this.state.rowClassRules}
          selectionChange={this.selectionChange}
          //onSelectionChanged={this.onSelectionChanged.bind(this)}
          tooltipShowDelay="0"
        >
        </AgGridReact>
      </div>;
    }

    const renderARBucketDetailsGrid = () => {
      return <div className={`ag-theme-alpine ${appConstants.isR3App ? "apGridR3" : "apGrid"}`}
        style={{ height: '220px' }}>
         {/* <ul>
        {this.state.trackHistory.map((e, idx) => (
          <li key={idx}>
            <strong>{e.date}</strong> - {e.eventDescription} - {e.derivedStatus} - ({e.city},{e.countryCode})
          </li>
        ))}
      </ul> */}

<AgGridReact
          columnDefs={this.state.colHistoryHeaders}
          rowData={this.props.trackHistory}
          //onGridReady={this.onGridReady}  
          rowHeight="30"
          headerHeight="30"
          rowSelection="single"
          rowClassRules={this.state.rowClassRules}
          selectionChange={this.selectionChange}
          //onSelectionChanged={this.onSelectionChanged.bind(this)}
          tooltipShowDelay="0"
        >
        </AgGridReact>
      </div>;
    }
    return (

      <div className="col-sm-10" >

        <div className="row" style={{ height: "33%", borderBottom: "1px solid rgba(0,0,0,.125)" }}>
          <div className="col-sm-12" >
            <h6>Last Activity</h6><br />
            <div className="col-sm-12">
              <div className="row">
                <div className="col-sm-2">
                  <label>
                    Status:
                  </label>
                </div>
                <div className="col-sm-1">
                  {this.props.status}
                </div>
              </div>
              <div className="row">
                <div className="col-sm-2">
                  <label
                    className="form-check-label"
                    for="inlineRadio2"
                    style={{ paddingTop: "4px" }}
                  >
                    Scheduled Delivery:
                  </label>
                </div>
                <div className="col-sm-1">
                  <label
                    className="form-check-label"
                    for="inlineRadio2" value={this.props.description}
                    style={{ paddingTop: "4px" }}
                  >

                  </label>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-2">
                  <label
                    className="form-check-label"
                    for="inlineRadio2"
                    style={{ paddingTop: "4px" }}
                  >
                    Shipped or Billed On:
                  </label>
                </div>
                <div className="col-sm-1">
                  <label
                    className="form-check-label"
                    for="inlineRadio2" value={this.props.description}
                    style={{ paddingTop: "4px" }}
                  >

                  </label>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-2">
                  <label
                    className="form-check-label"
                    for="inlineRadio2"
                    style={{ paddingTop: "4px" }}
                  >
                    Tracking Number:
                  </label>
                </div>
                <div className="col-sm-1">
                  <label
                    className="form-check-label"
                    for="inlineRadio2"
                    style={{ paddingTop: "4px" }}
                  >
                    {this.props.trackinginofnumber}
                  </label>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-2">
                  <label
                    className="form-check-label"
                    for="inlineRadio2"
                    style={{ paddingTop: "4px" }}
                  >
                    Service Type:
                  </label>
                </div>
                <div className="col-sm-1">
                  <label
                    className="form-check-label"
                    for="inlineRadio2" value={this.props.description}
                    style={{ paddingTop: "4px" }}
                  >

                  </label>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-2">
                  <label
                    className="form-check-label"
                    for="inlineRadio2"
                    style={{ paddingTop: "4px" }}
                  >
                    Package Weight:
                  </label>
                </div>
                <div className="col-sm-1">
                  <label
                    className="form-check-label"
                    for="inlineRadio2"
                    style={{ paddingTop: "4px" }}
                  >
                    {this.props.weight} <b>{this.props.isFedex}</b>
                  </label>
                </div>
              </div>
            </div>

          </div>

        </div>
        <div className="row" style={{ height: "50%"  }}>
          <div className="col-sm-12" >
            <h6>Package Progress </h6><br />
            {renderARBucketGrid()}
            <div>NOTICE: UPS/Fedex tracking systems and the information they contain are the private property of UPS/Fedex and may be used solely to track shipments shipped by or to you and for no other purpose. You may not make the information obtained through the tracking systems available on any web site or otherwise distribute the information.</div>
          
            </div>
        </div>

        {/* <div className="row" style={{ height: "26%", overflowY: 'auto',    }}>
          <div className="col-sm-12" >
            <h6>Package Details</h6><br />
            {renderARBucketDetailsGrid()}
          
            <div>NOTICE: UPS/Fedex tracking systems and the information they contain are the private property of UPS/Fedex and may be used solely to track shipments shipped by or to you and for no other purpose. You may not make the information obtained through the tracking systems available on any web site or otherwise distribute the information.</div>
          </div>
        </div> */}
      </div>
    );
  };
}
export default UPSTrackingInfo;